import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  highlight(event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return

    const row = this.element.closest("tr")
    const table = row?.closest("table")
    if (!table) return

    table.querySelectorAll("tr.last-opened-lead").forEach(previousRow => {
      previousRow.classList.remove("last-opened-lead")
    })
    row.classList.add("last-opened-lead")
  }
}
